import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import qs from "qs";
import { type FunctionComponent, useEffect, useState } from "react";

import { notEmpty } from "shared/lib/utils";

import { usePlusBlurbPopup } from "scmp-app/components/plus/blurb-popup/hooks";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import {
  page as PlusLearnMorePage,
  pathname as plusLearnMorePathname,
} from "scmp-app/pages/plus/learnmore/index";

export type Props = {
  children?: React.ReactNode;
};

export const PlusPaywallHookRunner: FunctionComponent<Props> = ({ children }) => {
  const router = useRouter();
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { checkPlusHomepagePathOnly } = usePlusBlurbPopup();

  const hasScmpPlusAccessRight = asyncRosettaState?.result?.hasScmpPlusAccessRight ?? false;

  const [pass, setPass] = useState(false);

  useEffect(() => {
    if (hasScmpPlusAccessRight) setPass(true);
  }, [hasScmpPlusAccessRight]);

  useEffect(() => {
    if (plusLearnMorePathname === router.pathname) return;
    if (
      !notEmpty(asyncRosettaState) ||
      asyncRosettaState?.status === "loading" ||
      !asyncRosettaState?.result?.hasPianoExperienceExecuted ||
      hasScmpPlusAccessRight
    )
      return;

    const redirectToPaywallPage = () => {
      const { pathname: plusLearnMorePagePathname } = PlusLearnMorePage.route({});

      const parsedQueryString = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      }) as Record<string, string>;

      void router.replace({
        pathname: plusLearnMorePagePathname,
        query: parsedQueryString,
      });
    };

    if (checkPlusHomepagePathOnly) return;

    redirectToPaywallPage();
  }, [asyncRosettaState, checkPlusHomepagePathOnly, hasScmpPlusAccessRight, router]);

  return pass ? children : null;
};
PlusPaywallHookRunner.displayName = "PlusPaywallHookRunner";
